module.exports = __webpack_public_path__ + "img/mobile-phones.41c9a8d6.png";